'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import React from 'react';
import { excludeComponentProps } from '../utils/excludeComponentProps';
import { headerCssClassNames } from './headerCssClassNames';
const StyledHeaderActionArea = styled('div', {
    ...excludeComponentProps('disableSpacing')
})(({ theme, disableSpacing }) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'end',
    marginLeft: theme.tokens.FuelSpacing2,
    color: theme.tokens.FuelColorTextPrimary,
    fontSize: theme.tokens.FuelFontSizeBase,
    ...!disableSpacing && {
        '& > :not(:first-of-type)': {
            marginLeft: theme.tokens.FuelSpacing2
        }
    }
}));
/**
 * Wrapper for Header Component children
 */
export const HeaderActionArea = React.forwardRef(({ disableSpacing, ...props }, ref) => (_jsx(StyledHeaderActionArea, { ...props, className: headerCssClassNames.actionArea, disableSpacing: disableSpacing, ref: ref })));
HeaderActionArea.displayName = 'HeaderActionArea';
